import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTextHeight, faCircleHalfStroke, faBell, faClose, faCircle,
} from '@fortawesome/free-solid-svg-icons';

import { useAccessibilityContext } from 'contexts/AccessibilityContext';

import './AccessibilityButtons.css';
import { usePageMaskContext } from 'contexts/PageMaskContext';
import { useTeleconsultingContext } from 'contexts/TeleconsultingContext';
import { Box, Menu, MenuItem, withStyles } from '@material-ui/core';
import { NotificationsCard } from '../NotificationsCard';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    top: '65px !important',
    width: '300px !important',
    left: 'auto !important',
    right: '48px !important',
    '@media (min-width: 600px)': {
     right: '115px !important'
    }
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    padding:'0px',
    width:"300px"
  },
  
}))(MenuItem);


export function AccessibilityButtons() {
  const { handleContrastChange, handleTextSizeChange } = useAccessibilityContext();
  const { pageMaskState, handleNotificationEvent } = usePageMaskContext();
  const { appointment } = useTeleconsultingContext();
  // const actualDateTime = new Date('2022-11-21T16:29:45.000-03:00').toISOString();
  const actualDateTime = new Date(Date.now()).toISOString();
  const booked = appointment?.entry?.filter((element) => new Date(actualDateTime) < new Date(element.resource.end));

  // const finished = appointment?.entry?.filter((element) => new Date(actualDateTime) > new Date(element.resource.end));

  return (
    <Box display="flex" justifyContent="space-between" width={100} className="accessibilityButtons-container">
      <Box className="iconBox" onClick={handleTextSizeChange}>
        <FontAwesomeIcon icon={faTextHeight} />
      </Box>
      <Box className="iconBox" onClick={handleContrastChange}>
        <FontAwesomeIcon icon={faCircleHalfStroke} />
      </Box>
      <Box className="iconBox" onClick={handleNotificationEvent}>
        <FontAwesomeIcon icon={faBell}/>
      </Box>
      {
          booked?.length > 0 &&   
          <FontAwesomeIcon className='active-notification' icon={faCircle} />
         
       
      }

      {pageMaskState.notification && (
        <StyledMenu open={handleNotificationEvent} onClose={handleNotificationEvent}>
            <Box 
             display="flex" 
             flexDirection='row'
             justifyContent='space-between' 
             alignItems='center' 
             paddingTop='8px'
             paddingBottom='5px'
             borderBottom='1px solid #CCCCCC'
             >
            <div className='notification-header'>
            <FontAwesomeIcon icon={faBell} />
            <p className='notificationsTitle'>Notificações</p>
            </div>
            <FontAwesomeIcon className='closeNotification' icon={faClose} onClick={handleNotificationEvent} />
            </Box>
       
            {
              booked.length ?  booked?.map((document) => (
                <StyledMenuItem
                  key={`${document.resource.id}`}
                >
                  <NotificationsCard data={document} />
                </StyledMenuItem>
              )) : <p className='empty-notifications'>Nenhuma notificação ativa </p>             
            }
          
        </StyledMenu>
      )}
    </Box>

  );
}
